import { IQuestFragment } from 'generated/graphql-gateway';

import { IQuest, IQuestStep, QuestError, QuestValidationError } from './types';

export const validateQuest = (quest: IQuest): QuestError[] => {
  const errors: QuestError[] = [];

  if (!quest?.cmsId) {
    errors.push({
      error: QuestValidationError.INVALID_CMS_DOCUMENT,
      message: `No cms document [${quest.id}]`,
    });
  }

  return errors;
};

export const createQuest = ({
  id,
  incentiveType,
  endDate,
  startDate,
  sanityId,
  status,
  steps,
  bonusPoints,
  lastCompletion,
}: IQuestFragment): IQuest => ({
  cmsId: sanityId || '',
  startDate,
  endDate,
  id,
  incentiveType,
  lastCompletion: lastCompletion || null,
  status,
  steps: (steps as IQuestStep[]) || null,
  bonusPoints,
});
